import MobileModal from "components/MobileModal";
import useIsMobile from "pages/EDCFlow/hooks/useIsMobile";
import { getDocumentsRequiredIcon } from "pages/Questionnaire/constant";
import { Modal } from "x-wings";
import CrossIcon from "./CrossIcon";
import TickIcon from "./TickIcon";

export type TCorrectAndWrongWayModalPropsType = {
	open: boolean;
	onClose: () => void;
	documentRequiredQuestion?: PopulatedQuestion | null | undefined;
};

const CorrectAndWrongWayModal: React.FC<TCorrectAndWrongWayModalPropsType> = ({
	open,
	documentRequiredQuestion,
	onClose
}) => {
	const isMobile = useIsMobile();

	const hasWrongWay = documentRequiredQuestion?.wrong_way && documentRequiredQuestion.wrong_way?.info.length > 0;
	const hasCorrectWay =
		documentRequiredQuestion?.correct_way && documentRequiredQuestion.correct_way?.info.length > 0;

	const MModal = isMobile ? MobileModal : Modal;

	if (!documentRequiredQuestion) return null;

	return (
		<MModal
			open={open}
			onCancel={onClose}
			width="856px"
			styles={{
				content: !isMobile
					? {
							borderRadius: "1rem",
							background: "white",
							padding: "8px"
					  }
					: {},
				body: {
					padding: 0,
					background: "none",
					marginTop: "4px",
					marginBottom: "4px",
					boxShadow: "none"
				}
			}}
			title={
				<div>
					<div className="relative isolate flex items-center gap-3 md:ps-2">
						<img
							src={getDocumentsRequiredIcon(documentRequiredQuestion.icon)}
							alt={
								documentRequiredQuestion?.icon ?? documentRequiredQuestion?.doc_category ?? "Generic Doc"
							}
							width={24}
							height={24}
							className="hidden size-8 md:block md:size-6"
						/>
						<p className="text-[20px] font-sans font-medium leading-7 tracking-[-0.25px] text-gray-900 md:text-[15px] md:leading-[18px] md:tracking-[-0.13px]">
							{documentRequiredQuestion?.doc_category}
						</p>
					</div>
					{documentRequiredQuestion?.short_description && (
						<p className="block text-base font-normal tracking-[-0.12px] text-gray-700 md:hidden">
							{documentRequiredQuestion?.short_description}
						</p>
					)}
				</div>
			}
			footer={
				hasWrongWay || hasCorrectWay ? (
					<ul className="flex list-decimal flex-col items-start justify-stretch whitespace-pre-wrap ps-7 text-start text-[12px] font-medium tracking-[0.01px] text-gray-900 md:gap-3 md:ps-3.5 md:leading-[15px]">
						{documentRequiredQuestion?.wrong_way?.info?.map((_, index) => (
							<li key={index + "wrong_way"}>{_}</li>
						))}
						{documentRequiredQuestion?.correct_way?.info?.map((_, index) => (
							<li key={index + "correct_way"}>{_}</li>
						))}
					</ul>
				) : null
			}>
			<div className="relative flex h-[var(--h)] max-h-[var(--h)] min-h-[var(--h)] max-w-full flex-col-reverse items-stretch justify-stretch gap-1 overflow-hidden rounded-b-2xl rounded-t-[4px] [--h:100%] md:flex-row md:rounded-b-xl md:rounded-t-xl md:[--h:420px] [&>div]:h-[calc(var(--h)/2)] md:[&>div]:h-[var(--h)]">
				{/* Wrong way */}
				{documentRequiredQuestion?.wrong_way?.s3_path && (
					<div className="relative grid w-full flex-1 grid-cols-1 grid-rows-1 place-items-center overflow-clip bg-red-100 p-5">
						<span className="absolute top-6 inline-grid size-9 place-items-center rounded-full border-[1.5px] border-white/20 bg-[#E62E05] bg-gradient-to-b from-white/20 to-white/0 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.06),0px_1.5px_0px_0px_rgba(255,255,255,0.40)_inset] ring-1 ring-[#97180C]">
							<CrossIcon />
						</span>
						<img
							src={documentRequiredQuestion?.wrong_way?.s3_path}
							alt="Wrong Way"
							className="max-h-full max-w-full object-contain shadow-lg"
						/>
					</div>
				)}
				{/* Correct way */}
				{documentRequiredQuestion?.correct_way?.s3_path && (
					<div className="relative grid w-full flex-1 grid-cols-1  grid-rows-1 place-items-center overflow-clip bg-[#DCFCE7] p-5">
						<span className="absolute top-6 inline-grid size-9 place-items-center rounded-full border-[1.5px] border-white/20 bg-[#16A34A] bg-gradient-to-b from-white/20 to-white/0 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.06),0px_1.5px_0px_0px_rgba(255,255,255,0.40)_inset] ring-1 ring-[#166534]">
							<TickIcon />
						</span>
						<img
							src={documentRequiredQuestion?.correct_way?.s3_path}
							alt="Correct Way"
							className="max-h-full max-w-full object-contain shadow-lg"
						/>
					</div>
				)}
			</div>
		</MModal>
	);
};

export default CorrectAndWrongWayModal;
